/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Translation_Merge_Source_Group_HelpInputs */

const en_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The source group is used to populate the source events for translation.`)
};

const fr_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Le groupe source est utilise pour remplir les evenements source pour la traduction.`)
};

const de_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Quellgruppe dient dazu, die Quellereignisse für die Übersetzung zu füllen.`)
};

const it_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il gruppo sorgente viene utilizzato per popolare gli eventi sorgente per la traduzione.`)
};

const ru_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Группа источников используется для заполнения событий-источников для перевода.`)
};

const es_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El grupo de origen se utiliza para completar los eventos de origen para la traducción.`)
};

const zh_cn2_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`源组用于填充要翻译的源事件。`)
};

const ja_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ソース グループは、翻訳のソース イベントを入力するために使用されます。`)
};

const hi_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`स्रोत समूह का उपयोग अनुवाद के लिए स्रोत घटनाओं को भरने के लिए किया जाता है।`)
};

const pt_pt2_translation_merge_source_group_help = /** @type {(inputs: Translation_Merge_Source_Group_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O grupo de origem é usado para preencher os eventos de origem para tradução.`)
};

/**
* | output |
* | --- |
* | "The source group is used to populate the source events for translation." |
*
* @param {Translation_Merge_Source_Group_HelpInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const translation_merge_source_group_help = /** @type {((inputs?: Translation_Merge_Source_Group_HelpInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Translation_Merge_Source_Group_HelpInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_translation_merge_source_group_help(inputs)
	if (locale === "de") return de_translation_merge_source_group_help(inputs)
	if (locale === "it") return it_translation_merge_source_group_help(inputs)
	if (locale === "ru") return ru_translation_merge_source_group_help(inputs)
	if (locale === "es") return es_translation_merge_source_group_help(inputs)
	if (locale === "zh-CN") return zh_cn2_translation_merge_source_group_help(inputs)
	if (locale === "ja") return ja_translation_merge_source_group_help(inputs)
	if (locale === "hi") return hi_translation_merge_source_group_help(inputs)
	if (locale === "pt-PT") return pt_pt2_translation_merge_source_group_help(inputs)
	return en_translation_merge_source_group_help(inputs)
});